import {Component, Input, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {
  SaveInitialMessageFromRepairCentreToGlobalService
} from "./services/save-initial-message-from-repair-centre-to-global.service";
import {debounceTime, distinctUntilChanged, Subject, switchMap} from "rxjs";
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";
import {FormsModule} from "@angular/forms";

@Component({
  selector: 'app-initial-message-from-repair-centre-to-global',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './initial-message-from-repair-centre-to-global.component.html',
  styleUrl: './initial-message-from-repair-centre-to-global.component.scss'
})
export class InitialMessageFromRepairCentreToGlobalComponent implements OnInit {

  @Input() claimDto!: ClaimDto;
  message$ = new Subject<string | null>();

  constructor(private saveInitialMessageFromRepairCentreToGlobalService: SaveInitialMessageFromRepairCentreToGlobalService) {

  }

  ngOnInit(): void {
    this.message$.pipe(
      debounceTime(2000),
      distinctUntilChanged(),
      switchMap(() => this.saveInitialMessageFromRepairCentreToGlobalService.saveInitialMessageFromRepairCentreToGlobal(this.claimDto.claimId, this.claimDto.initialMessageFromRepairCentreToGlobal))
    ).subscribe();
  }

  updateMessage() {
    this.message$.next(this.claimDto.initialMessageFromRepairCentreToGlobal);
  }

}
